import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { PropertyCommunityInfoResultDto } from '../../_models/property-community-info-result-dto';
// Service imports
import { MPCacheRegistrationService } from '../shared-services/mp-cache-registration-service';
// constants imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../shared-services/mp-cache-registration-service";
export class ContextManagerService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
        this._subjectContext = new Subject();
    }
    updateContext(val) {
        if (JSON.stringify(val) !== JSON.stringify(this._selectedContext)) {
            this._selectedContext = val;
            this._subjectContext.next(val);
        }
    }
    getContext() {
        return this._subjectContext;
    }
    getSelectedContext() {
        return this._selectedContext;
    }
    setSelectedContextRouteItem(val) {
        this._selectedContextRouteItem = val;
    }
    getSelectedContextRouteItem() {
        return this._selectedContextRouteItem;
    }
    getContextInfo(baseParams) {
        const url = `${URLConstants.ccOwnerApiBaseUrl}propertycommunityinfo${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(PropertyCommunityInfoResultDto, response)));
    }
}
ContextManagerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContextManagerService_Factory() { return new ContextManagerService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: ContextManagerService, providedIn: "root" });
